import { render, staticRenderFns } from "./ClinicsPage.vue?vue&type=template&id=1f0cd39c&scoped=true&"
import script from "./ClinicsPage.vue?vue&type=script&lang=js&"
export * from "./ClinicsPage.vue?vue&type=script&lang=js&"
import style0 from "./ClinicsPage.vue?vue&type=style&index=0&id=1f0cd39c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0cd39c",
  null
  
)

export default component.exports